import { updateVideoQuality } from "../features/base/video-quality/actions";
import { reflowDragableVideo } from "../features/screen-share/ScreenshareUI";
import {Video} from "../libs/roomnew";

export default class Presenter {
    constructor(){
        this.activePresneter={
            id:null,
            lastPosition:null,
            sharingScreen:false
        };
        this.minimizedVideosContainer=$("#presenterStripVideos");
        this.isPresenterView=false;
        this.usersSharingScreen={};
        this.tooltip = null;
    };

    makePresenter(id){
        var p=this;
        if(p.activePresneter.id){
            p.removePresenter();
        }
        p.activePresneter.id=id;
        if(!p.isPresenterView){
            p.showPresneterView();
        }else{
            //fix when switching participants local video remains maximized
            if(Video.isLocalMaximized){
                Video.localVideoMinimize();
            }
        }
        p.animateMaximize(id);
        // Video.setQuality();
        updateVideoQuality()
    };

    removePresenter(switchView=false){
        console.error("removePresenter:",switchView);
        var p=this;
        try {
           if(p.activePresneter.id){
               //animate minimize
               p.animateMinimize(p.activePresneter.id);
               p.activePresneter.id=null;
               p.activePresneter.lastPosition=null;
               p.activePresneter.sharingScreen=false;
                if(switchView){p.hidePresenterView();}
           }else{
            p.hidePresenterView();
           }
        //    Video.setQuality();
        updateVideoQuality()
        } catch (error) {

        }
    };

    isPresenter(id){
        console.log("isPresenter:"+id);
        return this.activePresneter.id == id;
    };
    getPresenterId(){
        // console.log("getPresenterId function");
        return this.activePresneter.id;
    };
    animateMaximize(id){
        var p=this;
        try {
            if (Video.videos[id].viewContainer[0].parentElement.id == 'presenterStripVideos') {
                Video.videos[id].viewContainer.appendTo(Video.remoteVideosContainer);
            }

            Video.videos[id].bottomToolbar.find(".kino-tooltip-container").remove();
            Video.videos[id].viewContainer.addClass("presenter-tile");
            Video.videos[id].presenterBtn.html(Video.minimizeIcon);
            Video.videos[id].presenterBtn.attr('title', 'Minimize');
            Video.videos[id].presenterBtn.attr('data-original-title', 'Minimize');
            Video.videos[id].presenterBtn.tooltip('hide');
            let height = Video.remoteVideos.innerHeight();
            height=height-120;
            let width = parseInt(height * Video.videoRatio);
            console.log("width of video:" + width);
            Video.videos[id].viewContainer.animate({
                width: width + "px",
                height: height + "px"
            },200,"linear");
            reflowDragableVideo(id);
        } catch (error) {

        }


    };

    maximizeVideo(id){
        try {
            this.presenterButtonUI(id,"minimize");
            Video.localVideoMinimize();
        } catch (error) {

        }
    };

    minimizeVideo(id){
        try {
            this.presenterButtonUI(id,"maximize");
            Video.localVideoMaximize();
        } catch (error) {

        }
    };

    presenterButtonUI(id,uiState="minimize"){
        try {
            if(uiState=="minimize"){
                Video.videos[id].presenterBtn.html(Video.minimizeIcon);
                Video.videos[id].presenterBtn.attr('title', 'Minimize');
                Video.videos[id].presenterBtn.attr('data-original-title', 'Minimize');
                Video.videos[id].presenterBtn.tooltip('hide');
                Video.videos[id].viewContainer.addClass('maximized');
            }else{
                Video.videos[id].presenterBtn.html(Video.maximizeIcon);
                Video.videos[id].presenterBtn.attr('title', 'Maximize');
                Video.videos[id].presenterBtn.attr('data-original-title', 'Maximize');
                Video.videos[id].presenterBtn.tooltip('hide');
                Video.videos[id].viewContainer.removeClass('maximized');
            }
        } catch (error) {

        }
    }

    animateMinimize(id){
        var p=this;
        Video.videos[id].viewContainer.removeClass("presenter-tile");
        Video.videos[id].presenterBtn.html(Video.maximizeIcon);
        Video.videos[id].presenterBtn.attr('title', 'Maximize');
        Video.videos[id].presenterBtn.attr('data-original-title', 'Maximize');
        Video.videos[id].presenterBtn.tooltip('hide');

        Video.videos[id].viewContainer.appendTo(p.minimizedVideosContainer);
        Video.videos[id].viewContainer.css({
            width: "",
            height: ""
        });
        reflowDragableVideo(id);
    };

    showPresneterView(){
        var p=this;
        if(p.getPresenterId()==null){return}
        if(Video && Video.mainParticipants[p.getPresenterId()]==undefined){return}
        p.isPresenterView = true;
        Video.remoteVideos.addClass("sharescreen-view");
        if(Video.isLocalMaximized){
            Video.localVideoMinimize();
        }
        $.each(Video && Video.mainParticipants, function (pid) {
            if (pid !== p.getPresenterId()) {
                if (Video.videos[pid] !== undefined) {
                    Video.videos[pid].viewContainer.appendTo(p.minimizedVideosContainer);
                }
            }
        });
    };

    hidePresenterView(){
        console.log("hidePresenterView function");
        var p=this;
        Video.remoteVideos.removeClass("sharescreen-view");
        p.isPresenterView = false;
        $.each(Video && Video.mainParticipants, function (pid) {
            if (Video.videos[pid] !== undefined) {
                Video.videos[pid].viewContainer.removeClass("presenter-tile");

                if (Video.videos[pid].viewContainer[0].parentElement.id == 'presenterStripVideos') {
                    Video.videos[pid].viewContainer.css({
                            width: "",
                            height: ""
                        });
                   Video.videos[pid].viewContainer.appendTo(Video.remoteVideosContainer);
                }
            }
        });
        Video.isFocusedSafeView();
        Video.isOnlyOne();
        Video.resizeMainVideos();
    };
    canMakePresenterActive(){
        var p=this;
        if(Video && Object.keys(Video.mainParticipants).length > 1){
            p.showButtons();
        }else{
            p.hideButtons();
            if(p.isPresenterView){
                p.removePresenter(true);
            }
        }

    };

    isPresenterAvailable(){
        if(Video && Object.keys(Video.mainParticipants).length > 1){
            return true;
        }else{
            return false;
        }
    };

    showButtons(){
        var p=this;
        $.each(Video && Video.mainParticipants, function (pid) {
            if (Video.videos[pid] !== undefined) {
                   Video.videos[pid].presenterBtn.removeClass('hidden');
            }
        });
    };
    hideButtons(){
        // $.each(Video && Video.mainParticipants, function (pid) {
        //     if (Video.videos[pid] !== undefined) {
        //            Video.videos[pid].presenterBtn.addClass('hidden');
        //     }
        // });
    };

    showTooltip(id){
        var p=this;
        console.log("show tooltip");

        let text=$("<p/>",{
            class:"tooltip-inside-text",
            html:"Click here to maximize this video"
        });
        let closeBtn=$("<div/>",{
            class:"fa tooltip-exit-btn",
            html:"&#xf00d;"
        });
        p.tooltip=$("<div/>",{
            class:"kino-tooltip-container align-left presenter",
            pid:id,
            html:[text,closeBtn]
        }).on('click',(e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        let timeoutFunc=0;
        closeBtn.on('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            clearTimeout(timeoutFunc);
            localStorage.setItem('share_screen_tooltip_rejected',1);
            Video.videos[id].presenterBtn.removeClass('show').removeClass('noticeable').removeClass('animate')
            Video.videos[id].topToolBarRight.css('overflow','hidden');
            p.hideTooltip(p.tooltip);
        });
        if (Video.videos[id] !== undefined) {
            Video.videos[id].presenterBtn.append(p.tooltip);
            Video.videos[id].topToolBarRight.css('overflow','visible');
            Video.videos[id].presenterBtn.addClass('show').addClass('noticeable').addClass('animate')
            p.tooltip.css("display","flex");
            p.tooltip.animate({opacity:1},100);
            $('')
            timeoutFunc=setTimeout(() => {
                p.hideTooltip(p.tooltip);
                Video.videos[id].presenterBtn.removeClass('show').removeClass('noticeable').removeClass('animate')
            }, 10000);
        }

    };

    hideTooltip(){
        try {
            if(this.tooltip){
                if(this.tooltip.attr('pid')){
                    Video.videos[this.tooltip.attr('pid')].presenterBtn.removeClass('show noticeable animate');
                    Video.videos[this.tooltip.attr('pid')].topToolBarRight.css('overflow','hidden');
                }
                this.tooltip.animate({opacity:0},100,"linear",()=>{
                     this.tooltip.remove();
                     this.tooltip=null;
                 });
            }
        } catch (error) {

        }

    };

    shareScreenEvent(data){
        var p=this;
        console.error('presenter data: ',data);
        try {
           if(data.status=="started"){
                if(p.canShowTooltip(data.participant)){p.showTooltip(data.participant);}
            }
        } catch (error) {
            console.error("Share screen event error:",error);
        }

    };

    canShowTooltip(id){
        var p=this;
        if(Video.mainParticipants[id]==undefined){return false}
        if(p.isPresenterView){return false}
        if(localStorage.getItem('share_screen_tooltip_rejected')){return false}
        if(Object.keys(Video.mainParticipants).length <= 1){
            if(Object.keys(Video.mainParticipants).length==1 && Object.keys(Video.mainParticipants)[0]==id){
                if(!Video.videos[Object.keys(Video.mainParticipants)[0]].viewContainer.hasClass('maximized')){
                    return true
                }
            }
            return false
        }
        return true;
    };



};
